export default "__VITE_ASSET__CNenrWL8__"